module.exports = __webpack_public_path__ + "static/media/08_hi.424dea6b.png";